import { DiamondCardModal } from "./DiamondCardModal";

export default DiamondCardModal;
